<template>
	<div>
		<notifications></notifications>
		<pending />
		<router-view></router-view>
	</div>
</template>

<script>

	export default {
		data() {
			return {
				default: null
			}
		},
		created() {
			window.document.title = this.translate(this.locale.headTitle);

			// if(String(this.$store.state.authentication.authToken).length < 64 || this.$store.state.authentication.authToken == null) {
			// 	this.$store.state.authentication.checked = true;
			
			// } else {
				
			// 	this.$http.get(this.config.api + "/admin/authenticate").then(res => {

			// 		if (res.body.status == 'success') {
			// 			this.$store.state.authentication.loggedIn = true;
			// 			this.$store.state.authentication.user_hash = res.body.data.user_hash;
			// 			this.$store.state.authentication.user_name = res.body.data.user_name;
			// 			this.$store.state.authentication.user_role = res.body.data.user_role;
			// 			this.$store.state.authentication.checked = true;
			// 		}
			// 	})
			// }

			
		}
	}
</script>
<style>
	@media (min-width: 992px) {
		.show-web {
			display: block !important;
		}
		.show-mobile {
			display: none !important;
		}
	}
	@media (max-width: 991px) {
		.show-web {
			display: none !important;
		}
		.show-mobile {
			display: block !important;
		}
	}

	.vs__dropdown-option--highlight {
		background-color: rgba(0, 0, 0, 0.12);
		color: rgba(0, 0, 0, 0.87);
	}
	.vs__dropdown-toggle {
		border-radius: 0;
		border: none;
		margin-top: 3px;
		margin-bottom: 24px;
		border-bottom: 1px solid #CFCFCF;
	}
	.md-input::placeholder {
		font-size: 13px !important;
		color: #495057;
	}
	/* .md-card-header {
		display: none !important;
	} */
	.md-textarea {
		min-height: 80px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
		font-size: 14px;
	}

	.el-tabs__item.is-active {
		color: #2ec5b6 !important;
	}

	.el-tabs__item:hover {
		color: #2ec5b6 !important;
	}

	.el-tabs__active-bar {
		background-color: #2ec5b6 !important;
	}

	.md-progress-bar-fill {
		background-color: #2ec5b6 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.green {
		background-color: #2ec5b6;
		color: #FFF;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.neutral {
		background-color: #c189ee;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.late {
		background-color: #fab1a0;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.error {
		background-color: #f35734;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.gray {
		background-color: #bfbfbf;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.blue {
		background-color: #80e6ff;
		border-radius: 5px;
		margin-top: 5px;
		padding: 4px 8px;
	}

	.return {
		background-color: #fd79a8;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.md-list-item-text {
		font-family: "Open Sans", "Hanuman", sans-serif !important;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue